import { AXIOS_CONFIG } from './config';
import axios from 'axios';

const API_CONFIGS = {
    MASTER_PASSWORDS: 'master-passwords',
}

export const getAll = function () {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    return axiosInstance.get(`${API_CONFIGS.MASTER_PASSWORDS}` );
}

export const addNewPassword = function (data) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(API_CONFIGS.MASTER_PASSWORDS, data);
    return request;
}

export const deletePassword = function (id) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.delete(`${API_CONFIGS.MASTER_PASSWORDS}`, { params: { id } } );
    return request;
}

export const updatePasswordStatus = function(id, isActivated) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(`${API_CONFIGS.MASTER_PASSWORDS}/status`, { is_activated: isActivated }, { params: { id } });
    return request;
}

export const updatePassword = function(id, data) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.put(`${API_CONFIGS.MASTER_PASSWORDS}`, { data },{ params: { id } } );
    return request;
}

export const bulkDeletePasswords = function(ids) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(`${API_CONFIGS.MASTER_PASSWORDS}/bulk-delete`, { ids });
    return request;
}

export const exDeletePasswords = function(ids) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(`${API_CONFIGS.MASTER_PASSWORDS}/all-expired-delete`, { ids });
    return request;
}



// WEBPACK FOOTER //
// ./api/password.js